/* @flow */
import cx from 'classnames';
import * as React from 'react';
import Text from 'components/Text';
import Image from 'components/Image';
import MediaObject from 'components/MediaObject';
import { AvatarImages } from 'constants/AvatarConstants';

import './styles/GroupQuickSwitcherItem.scss';

type Props = {
  item: *,
  selected?: boolean,
};

class GroupQuickSwitcherItem extends React.Component<Props, void> {
  shouldComponentUpdate(nextProps: Props) {
    return this.props.selected !== nextProps.selected;
  }

  render() {
    const classnames = cx('GroupQuickSwitcherItem', {
      'GroupQuickSwitcherItem--selected': this.props.selected,
    });

    const icon = this.props.item.group_avatar
      ? this.props.item.group_avatar.svgUrl
      : AvatarImages.ORG_AVATAR;

    return (
      <div className={classnames}>
        <MediaObject center gutter="small">
          <Image className="NavigationListOrganizationItem-avatar" width={24} src={icon} />
          <Text className="GroupQuickSwitcherItem-name">{this.props.item.displayName}</Text>
        </MediaObject>
      </div>
    );
  }
}

export default GroupQuickSwitcherItem;
